import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

export function login(payload) {
  return axios.post(apiUrl.createJWT.POST, payload);
}

export function register(user) {
  return axios.post(apiUrl.signup.POST, user);
}

export function passwordRecovery(email) {
  return axios.post(apiUrl.passwordReset.POST, { email });
}

export function confirmNewPassword({ uid, token, new_password1, new_password2 }) {
  return axios.post(apiUrl.passwordResetConfirm.POST, { uid, token, new_password1, new_password2 });
}

export function changePassword({ password_old, password_new, password_confirm }) {
  return axios.post(apiUrl.passwordChange.POST, { password_old, password_new, password_confirm });
}

export function verifyToken(token) {
  return axios.post(apiUrl.verifyJWT.POST, { token });
}

export function refreshToken(refreshTokenValue) {
  return axios.post(apiUrl.refreshJWT.POST, { refresh: refreshTokenValue });
}
